import { ApiRequest } from "@plinknz/tah-website-elements";
import { RadioGroupChoice } from "../../../components/content-blocks/forms/customer-form-types";
import { registrationApi } from "../../../service/forms/register/api";
import { REGISTRATION_ENDPOINTS } from ".";

export interface Tupuna {
    id: string;
    value: string;
    nextId?: number;
}

interface SourceData {
    tupuna: Tupuna[];
}

interface TupunaProps {
    request?: ApiRequest;
    onLoad?: () => void;
}

export class Tupuna {
    public data: RadioGroupChoice[] = [];

    constructor({ request = registrationApi, onLoad }: TupunaProps) {
        request
            .get<SourceData>(REGISTRATION_ENDPOINTS.groups)
            .then((response) => {
                const sorted: Tupuna[] = response.data.tupuna.sort(
                    (a: Tupuna, b: Tupuna) => {
                        if (a.value > b.value) {
                            return 1;
                        }
                        if (a.value < b.value) {
                            return -1;
                        }
                        return 0;
                    }
                );

                this.data = sorted.map(({ id, value }) => ({
                    value: id,
                    text: value,
                }));

                if (onLoad) onLoad();
            });
    }
}
